document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 576) {
    let swiper = new Swiper(".customer_reviews", {
      slidesPerView: 3,
      spaceBetween: 20,
      sliderPerGroup: 3,
      loop: false,
      centerSlide: "true",
      fade: "true",
      grabCursor: "true",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        576: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 3,
        },
      },
    });
  }
});
